// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2i58a","imageUploader":"EGiftCard_imageUploader__35gpV"};